// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"99c11067","113":"922c0189","859":"afce2aae"}[chunkId] + ".chunk.css";
};